import { P2GGrid, P2GLink, P2GText, P2GBox, P2GLinkGroup, P2GAlert } from '@parcel2go/core-ui';
import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import ItemContents from './ItemContents';
import ItemMarketplaceDetails from './ItemMarketplaceDetails';
import ItemRecipient from './ItemRecipient';
import { SmartSendItemSelect } from '../SmartSendItemSelect';
import SmartSendItemInactiveDrop from './SmartSendItemInactiveDrop';
import { EventSections } from '../../../lib/events/EventLogger';
import P2GContentDropDown from '../../P2GContentDropDown';
import { TranslationNamespaces } from '~/lib/constants';
import { Trans, useTranslation } from 'react-i18next';

interface props {
  item: SmartSendItemApiModel;
  toggleSelect: (val: boolean) => void;
  restore: (select: boolean) => void;
  delete: () => void;
  removeTag: (tag: string) => void;
  saveTags: (tags: string[]) => void;
  isReturn: boolean;
}

export default function SmartSendItemInactive(props: props) {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  return (
    <div>
      <P2GBox p={1}>
        <SmartSendItemSelect selected={props.item.State.selected} toggle={props.toggleSelect}>
          <P2GGrid container spacing={1}>
            <P2GGrid item xs={12} sm={6} md={4}>
              <ItemContents item={props.item} variant="body2" />
            </P2GGrid>
            <P2GGrid item xs={12} sm={6} md={3}>
              <ItemRecipient customer={props.isReturn ? props.item.Sender : props.item.Recipient} variant="body2" />
            </P2GGrid>
            <P2GGrid item xs={12} sm={12} md={5}>
              <P2GAlert palette="primary">
                <P2GText variant="body2">
                  <strong>
                    {t('ITEM_SAVED_FOR_LATER_INFO', {
                      defaultValue: 'This item has been saved for later. Do you want to include it again?'
                    })}
                  </strong>
                </P2GText>
                <P2GLinkGroup
                  pb={0}
                  pt={1}
                  links={[
                    <P2GLink key="include" onClick={() => props.restore(props.item.State.selected)}>
                      {t('INCLUDE_LINK', { defaultValue: 'Include' })}
                    </P2GLink>,
                    !props.item.State.selected && (
                      <P2GLink key="include-and-select" onClick={() => props.restore(true)}>
                        {t('INCLUDE_AND_SELECT_LINK', { defaultValue: 'Include and Select' })}
                      </P2GLink>
                    )
                  ]}
                />
              </P2GAlert>
            </P2GGrid>
          </P2GGrid>
        </SmartSendItemSelect>
      </P2GBox>
      <ItemMarketplaceDetails
        section={EventSections.SmartSend}
        item={props.item}
        removeTag={props.removeTag}
        saveTags={props.saveTags}
        drop={
          <P2GContentDropDown
            control={
              <P2GLink variant="body2">
                <Trans t={t} i18nKey="QUICK_ACTIONS_LINK" defaults="Quick<br />Actions" />
              </P2GLink>
            }
          >
            <SmartSendItemInactiveDrop restore={props.restore} deleteItem={props.delete} direction="column" />
          </P2GContentDropDown>
        }
      />
    </div>
  );
}
